import { useGetLabelFoldersQuery } from 'features/metadata/metadata';
import { useActiveOrganisation } from 'hooks/useActiveOrganisation';
import Constants from 'config/Constants';
import { useMemo } from 'react';
import { createSelector } from '@reduxjs/toolkit';

const emptyArray = [];

export function useGetLabelFolders(entityType) {
    const activeOrganisation = useActiveOrganisation();

    const filterFolders = useMemo(() => {
        // Return a unique selector instance for this page so that
        // the filtered results are correctly memoized
        return createSelector(
            (res) => res.data,
            (_data, entityType) => entityType,
            (data, entityType) => {
                if (!data) {
                    return emptyArray;
                }

                // Filter by entity type?
                if (entityType) {
                    const allowedTypes = Object.keys(Constants.labelFolderEntities).filter((_entity) => {
                        return Constants.labelFolderEntities[_entity].includes(entityType);
                    });

                    return data.filter((labelFolder) =>
                        labelFolder.contentTypes.some((_type) => allowedTypes.includes(_type)),
                    );
                }

                return data;
            },
        );
    }, []);

    const { labelFolders } = useGetLabelFoldersQuery(
        { organisationId: activeOrganisation },
        {
            selectFromResult: (result) => ({
                labelFolders: filterFolders(result, entityType),
            }),
        },
    );

    return labelFolders;
}
